import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import WarehouseService from "../../services/WarehouseService";

export default function WarehouseDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [warehouse, setWarehouse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      loadWarehouseDetail(id);
    }
  }, [id]);

  const loadWarehouseDetail = async (warehouseId) => {
    setLoading(true);
    try {
      const res = await WarehouseService.getDetail(warehouseId);
      if (res.success) {
        setWarehouse(res.data);
      }
    } catch (error) {
      console.error("Depo detayları yüklenirken hata oluştu:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!warehouse && !loading) {
    return <div className="p-4 text-center">Depo bulunamadı.</div>;
  }

  return (
    <div className="p-4 space-y-4 animate-fade-in">
      {/* Üst Bilgi Kartı */}
      <div className="bg-white shadow-lg border border-slate-200 rounded-2xl p-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="!bg-blue-600 p-4 rounded-2xl shadow-lg">
              <i className="pi pi-home text-white text-2xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">
                {warehouse?.name || "Yükleniyor..."}
              </h1>
              <p className="text-slate-400 text-sm font-medium">
                <i className="pi pi-map-marker mr-1"></i> {warehouse?.address || "Adres belirtilmemiş"}
              </p>
            </div>
          </div>
          <Button
            label="LİSTEYE DÖN"
            icon="pi pi-arrow-left"
            className="p-button-text font-black text-slate-600"
            onClick={() => navigate("/warehouses")}
          />
        </div>
      </div>

      {/* Ürün Listesi Kartı */}
      <div className="bg-white shadow-lg border border-slate-200 rounded-2xl p-5">
        <div className="flex items-center gap-2 mb-6">
          <i className="pi pi-box text-blue-600 font-bold"></i>
          <h2 className="text-lg font-black text-slate-800 uppercase tracking-tight">
            Depodaki Ürünler
          </h2>
        </div>

        <DataTable
          value={warehouse?.products || []}
          loading={loading}
          className="p-datatable-sm"
          responsiveLayout="scroll"
          emptyMessage="Bu depoda henüz ürün bulunmamaktadır."
        >
          <Column field="productName" header="Ürün Adı" className="font-bold" />
          <Column field="unit" header="Birim" />
          <Column
            field="quantity"
            header="Stok Miktarı"
            body={(row) => (
              <span className="font-black text-blue-600">
                {row.quantity.toLocaleString("tr-TR")}
              </span>
            )}
          />
          <Column field="lastSupplierName" header="Son Alınan Tedarikçi" className="text-slate-600 font-medium" />
        </DataTable>
      </div>
    </div>
  );
}
